import { render, staticRenderFns } from "./TextareaItem.vue?vue&type=template&id=10385518&scoped=true"
import script from "./TextareaItem.vue?vue&type=script&lang=js"
export * from "./TextareaItem.vue?vue&type=script&lang=js"
import style0 from "./TextareaItem.vue?vue&type=style&index=0&id=10385518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10385518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10385518')) {
      api.createRecord('10385518', component.options)
    } else {
      api.reload('10385518', component.options)
    }
    module.hot.accept("./TextareaItem.vue?vue&type=template&id=10385518&scoped=true", function () {
      api.rerender('10385518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/TextareaItem.vue"
export default component.exports